import { forwardRef } from 'react';
import { IconButtonProps, IconButton as ThemeIconButton } from 'theme-ui';
import Tip from './v1/Tip';
import { TippyProps } from '@tippyjs/react';

export interface CustomIconButtonProps extends IconButtonProps {
  tip?: TippyProps
}

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

const IconButton = forwardRef<HTMLButtonElement, CustomIconButtonProps>(({
  tip,
  ...props
}: CustomIconButtonProps, ref) => {
  return (
    <ConditionalWrapper
      condition={tip}
      wrapper={children => <Tip {...tip}>{children}</Tip>}
    >
      <ThemeIconButton
        ref={ref}
        {...props}
        sx={{
          cursor: props.disabled ? undefined : 'pointer',
          color: props.disabled ? '#aaa' : undefined,
        }}
      />
    </ConditionalWrapper>
  );
});

export default IconButton;
